module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "tab-content-qualification noselect"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "app"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enregistrer($event)
      }
    }
  }, [_c('div', {
    staticClass: "body-tab"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-9 left"
  }, [_c('div', {
    staticClass: "row area"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head left",
    attrs: {
      "data-testid": "qualificationsSalarie-title"
    }
  }, [_vm._v("QUALIFICATIONS")]), _vm._v(" "), (_vm.dateFinContrat) ? _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "inp-button-card ml-2 green",
    attrs: {
      "type": "button",
      "title": "Nouveau contrat",
      "data-testid": "qualificationsSalarie-nouveau-contrat-button"
    },
    on: {
      "click": function($event) {
        _vm.nouveauContrat()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Nouveau contrat")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card p-3 mb-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "convention-collective-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeConventionCollective),
      expression: "salarieCourant.CodeConventionCollective"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeConventionCollective", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyConvention]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeConventionCollectives), function(convention) {
    return _c('option', {
      domProps: {
        "value": convention.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(convention.Code + '/' + convention.Libelle) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Convention collective")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "code-classification-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeQualification),
      expression: "salarieCourant.CodeQualification"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "code-classification-select",
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeQualification", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyCodeClassification]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeQualificationsFiltrees), function(qualification) {
    return _c('option', {
      domProps: {
        "value": qualification.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(qualification.Code + (qualification.EstArchive ? ' (obsolète)' : '')) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Code classification")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "classification-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeClassification),
      expression: "salarieCourant.CodeClassification"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeClassification", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyClassification]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeClassificationsFiltrees), function(classification) {
    return _c('option', {
      domProps: {
        "value": classification.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(classification.Code + '/' + classification.Libelle + (classification.EstArchive ? ' (obsolète)' : '')) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Classification")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "intitule-du-poste-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.LibelleEmploi),
      expression: "salarieCourant.LibelleEmploi"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "required": "",
      "maxlength": "50",
      "disabled": !_vm.canModify,
      "list": "suggestionsLibelleEmploi"
    },
    domProps: {
      "value": (_vm.salarieCourant.LibelleEmploi)
    },
    on: {
      "change": _vm.modifyLibelleEmploi,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "LibelleEmploi", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Intitulé du poste")])]), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "suggestionsLibelleEmploi"
    }
  }, _vm._l((_vm.listeQualificationsSalarie), function(qualificationsSalarie) {
    return _c('option', {
      domProps: {
        "value": qualificationsSalarie.Libelle
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "reference-insee-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeCodeInsee),
      expression: "salarieCourant.CodeCodeInsee"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "reference-insee-select",
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeCodeInsee", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyPropertiesPrincipales]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeCodeInsees), function(codeInsee) {
    return _c('option', {
      domProps: {
        "value": codeInsee.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(codeInsee.Code + '/' + codeInsee.Libelle) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Référence insee")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "entree-du-salarie-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateEntree),
      expression: "dateEntree"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "data-testid": "entree-du-salarie-input",
      "placeholder": " ",
      "required": "",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateEntree)
    },
    on: {
      "change": _vm.modifyDateEntree,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateEntree = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Entrée du salarié")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "debut-du-contrat-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDebut),
      expression: "dateDebut"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "required": "",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateDebut)
    },
    on: {
      "change": _vm.modifyDateDebut,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDebut = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Début du contrat")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "motif-d-entree-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeMotifDebut),
      expression: "salarieCourant.CodeMotifDebut"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "motif-d-entree-select",
      "required": "",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeMotifDebut", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeMotifDebuts), function(motifDebuts) {
    return _c('option', {
      domProps: {
        "value": motifDebuts.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(motifDebuts.Code + '/' + motifDebuts.Libelle) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Motif d'entrée")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "temps-de-travail-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeDureeContrat),
      expression: "salarieCourant.CodeDureeContrat"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "temps-de-travail-select",
      "required": "",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeDureeContrat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyTempsTravail]
    }
  }, [_vm._l((_vm.listeDureeContrats), function(dureeContrats) {
    return _c('option', {
      domProps: {
        "value": dureeContrats.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(dureeContrats.Code + '/' + dureeContrats.Libelle) + "\n                                                            ")])
  }), _vm._v(" "), _c('option')], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Temps de Travail")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), (_vm.showNbForfaitJours.includes(_vm.salarieCourant.CodeClassification)) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "nb-forfait-jours-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NbForfaitJours),
      expression: "salarieCourant.NbForfaitJours"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.canModify,
      "required": ""
    },
    domProps: {
      "value": (_vm.salarieCourant.NbForfaitJours)
    },
    on: {
      "change": _vm.modifyForRubriques,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NbForfaitJours", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Nb forfait jours")])])]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.CodeDureeContrat == '02') ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "taux-temps-partiel-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.TauxTempsParciel),
      expression: "salarieCourant.TauxTempsParciel"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "step": "0.01",
      "min": "0",
      "max": "99",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.TauxTempsParciel)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "TauxTempsParciel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Taux temps partiel")])])]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.CodeNatureContrat == 'CDD') ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "duree-du-contrat-CDD-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dureeContrat),
      expression: "dureeContrat"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dureeContrat)
    },
    on: {
      "change": _vm.modifyDureeContrat,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dureeContrat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Durée du contrat (CDD)")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "fin-periode-d-essai-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFinPeriodeEssai),
      expression: "dateFinPeriodeEssai"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "data-testid": "fin-periode-d-essai-input",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateFinPeriodeEssai)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFinPeriodeEssai = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin période d'essai")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "mois-de-suspension-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.MoisSuspensionTransfert),
      expression: "salarieCourant.MoisSuspensionTransfert"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.MoisSuspensionTransfert)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "MoisSuspensionTransfert", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Mois de suspension")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3 horaires-presence-field"
  }, [_c('div', {
    staticClass: "inp-input icon horaires-presence-inp",
    class: {
      warning: _vm.showHorairesPresenceAlerte || _vm.hasHorairesError,
        'horaires-presence-inp--vide': !_vm.horairesPresenceRenseignes && !_vm.hasHorairesError,
        'is-disabled': !_vm.dataReady
    },
    attrs: {
      "data-testid": "horaires-presence-field"
    },
    on: {
      "click": function($event) {
        _vm.dataReady && _vm.openModalHoraireHebdo()
      }
    }
  }, [_c('input', {
    key: _vm.horairesPresenceLibelle,
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "",
      "disabled": !_vm.dataReady,
      "placeholder": " ",
      "title": _vm.isTempsPartiel ? 'Les horaires de présence sont obligatoires pour ce contrat' : 'Horaires de présence'
    },
    domProps: {
      "value": _vm.horairesPresenceLibelle
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Horaires de présence")]), _vm._v(" "), (_vm.showHorairesPresenceAlerte || _vm.hasHorairesError) ? _c('span', {
    staticClass: "icon-alerte ri-alert-line"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon-inner ri-pencil-line"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "fin-previsionnelle-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFinPrevisionnelle),
      expression: "dateFinPrevisionnelle"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateFinPrevisionnelle)
    },
    on: {
      "change": _vm.modifyDateFinPrevisionnelle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFinPrevisionnelle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin prévisionnelle")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "depart-du-salarie-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDepartSalarie),
      expression: "dateDepartSalarie"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.peutModifierDatesContrat
    },
    domProps: {
      "value": (_vm.dateDepartSalarie)
    },
    on: {
      "change": _vm.modifyDateDepartSalarie,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDepartSalarie = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Départ du salarié")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "fin-du-contrat-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFinContrat),
      expression: "dateFinContrat"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.peutModifierDatesContrat
    },
    domProps: {
      "value": (_vm.dateFinContrat)
    },
    on: {
      "blur": _vm.onDateFinContratChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFinContrat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin du contrat")])])])])]), _vm._v(" "), (_vm.departIsSet()) ? _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head left"
  }, [_vm._v("Départ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "inp-button-card ml-2 blue",
    attrs: {
      "type": "button",
      "title": "Faire la sortie"
    },
    on: {
      "click": function($event) {
        _vm.faireSortie()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-sign-out-alt mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Faire la sortie")])])])]) : _vm._e(), _vm._v(" "), (_vm.departIsSet()) ? _c('div', {
    staticClass: "card p-3 mb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeMotifDepart),
      expression: "salarieCourant.CodeMotifDepart"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeMotifDepart", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyMotifDepart]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeMotifsDepartFiltree), function(item) {
    return _c('option', {
      domProps: {
        "value": item.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(item.Code + '/' + item.Libelle) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Motif de départ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeMotifRuptureContrat),
      expression: "salarieCourant.CodeMotifRuptureContrat"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeMotifRuptureContrat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyMotifRuptureContrat, _vm.modifyMotifRuptureContrat]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeMotifRuptures), function(motifRupture) {
    return _c('option', {
      domProps: {
        "value": motifRupture.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(motifRupture.Code + '/' + motifRupture.Libelle) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Motif de la rupture du contrat")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateNotificationRupture),
      expression: "dateNotificationRupture"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify,
      "required": _vm.isDateNotificationRuptureRequired
    },
    domProps: {
      "value": (_vm.dateNotificationRupture)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateNotificationRupture = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Notification de rupture")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.TransactionEnCours),
      expression: "salarieCourant.TransactionEnCours"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "TransactionEnCours", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Oui")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Non")])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Transaction en cours")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDernierJourTravailleEtPaye),
      expression: "dateDernierJourTravailleEtPaye"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "required": "",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateDernierJourTravailleEtPaye)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDernierJourTravailleEtPaye = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Dernier jour travaillé")])])]), _vm._v(" "), (_vm.salarieCourant.CodeMotifDepart == '012') ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateEntretienPrealable),
      expression: "dateEntretienPrealable"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "required": "",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateEntretienPrealable)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateEntretienPrealable = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Entretien préalable")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.RefusCdiSuiteCdd),
      expression: "salarieCourant.RefusCdiSuiteCdd"
    }],
    staticClass: "input",
    attrs: {
      "disabled": _vm.salarieCourant.CodeNatureContrat != 'CDD',
      "required": _vm.salarieCourant.CodeNatureContrat == 'CDD'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "RefusCdiSuiteCdd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Oui")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Non")])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Refus de proposition CDI suite CDD")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.CodeMotifRuptureContrat == '43') ? _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Rupture Conventionelle")])]) : _vm._e(), _vm._v(" "), (_vm.salarieCourant.CodeMotifRuptureContrat == '43') ? _c('div', {
    staticClass: "card p-3 mb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateSignatureRuptConv),
      expression: "dateSignatureRuptConv"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.dateSignatureRuptConv)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateSignatureRuptConv = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Signature")])])])])]) : _vm._e(), _vm._v(" "), (_vm.departIsSet()) ? _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Préavis")])]) : _vm._e(), _vm._v(" "), (_vm.departIsSet()) ? _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NombreMoisPreavisCsp),
      expression: "salarieCourant.NombreMoisPreavisCsp"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.NombreMoisPreavisCsp)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NombreMoisPreavisCsp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Mois (CSP)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.MontantPreavisCsp),
      expression: "salarieCourant.MontantPreavisCsp"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.MontantPreavisCsp)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "MontantPreavisCsp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Montant (CSP)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.SalaireNetCsp),
      expression: "salarieCourant.SalaireNetCsp"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "maxlength": "50",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.SalaireNetCsp)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "SalaireNetCsp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Salaire net (CSP)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeTypePreavis),
      expression: "salarieCourant.CodeTypePreavis"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeTypePreavis", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyTypePreavis]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listTypesPreavis), function(item) {
    return _c('option', {
      domProps: {
        "value": item.Code
      }
    }, [_vm._v("\n                                                                " + _vm._s(item.Code + ' / ' + item.Libelle + (item.LibelleCourt == undefined ? '' : (' ' + item.LibelleCourt))) + "\n                                                            ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Type de préavis")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateDebutPreavis),
      expression: "dateDebutPreavis"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify || _vm.salarieCourant.CodeTypePreavis == 'PASPR',
      "required": ""
    },
    domProps: {
      "value": (_vm.dateDebutPreavis)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateDebutPreavis = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Début")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFinPreavis),
      expression: "dateFinPreavis"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "placeholder": " ",
      "disabled": !_vm.canModify || _vm.salarieCourant.CodeTypePreavis == 'PASPR',
      "required": ""
    },
    domProps: {
      "value": (_vm.dateFinPreavis)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFinPreavis = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Fin")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "m-0 col-lg-3 col-md-12 right"
  }, [_c('liste-rubriques-salarie-component', {
    ref: "listeRubriquesSalarieRef",
    attrs: {
      "salarieCourant": _vm.salarieCourant
    },
    on: {
      "isModified": _vm.modify
    }
  })], 1), _vm._v(" "), (_vm.errorMessage.length) ? _c('p', [_c('strong', [_vm._v("La saisie du salarié contient des erreurs :")]), _vm._v(" "), _c('ul', _vm._l((_vm.errorMessage), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }))]) : _vm._e()])])])]), _vm._v(" "), (_vm.isModified) ? _c('div', {
    staticClass: "validation-area mt-3"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])]) : _vm._e()]), _vm._v(" "), _c('modal-absences-futures-fin-de-contrat', {
    ref: "modalAbsencesFuturesFinDeContrat",
    attrs: {
      "data-backdrop": "static"
    },
    on: {
      "refreshAbsences": _vm.refreshAbsences
    }
  }), _vm._v(" "), _c('modal-transfert-absences-futures', {
    ref: "modalTransfertAbsencesFutures",
    attrs: {
      "data-backdrop": "static"
    },
    on: {
      "refreshAbsences": _vm.refreshAbsences
    }
  }), _vm._v(" "), (_vm.showModalHoraireHebdo) ? _c('modal-horaire-hebdo', {
    attrs: {
      "horaire-hebdo-initial": _vm.horaireHebdoPourModale,
      "heuresParSemaine": _vm.libelleHeuresPourModale
    },
    on: {
      "horaireHebdoUpdated": _vm.onHoraireHebdoUpdated,
      "closeModal": function($event) {
        _vm.showModalHoraireHebdo = false
      }
    }
  }) : _vm._e()], 1) : _c('loader', {
    staticClass: "loader"
  })
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "data-testid": "qualificationsSalarie-valider-button-field"
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cc183ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/qualifications/qualificationsSalarie.vue.html
// module id = tFfd
// module chunks = 2